import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  InputGroup,
  InputGroupPrepend,
  InputGroupText,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput,
} from '@met/react-components';
import React, { useEffect, useRef, useState } from 'react';

const AddLanguageModal = ({ hidden, toggle, onSaveClick }) => {
  const [language, setLanguage] = useState('');
  const [description, setDescription] = useState('');
  const languageRef = useRef(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!hidden) languageRef.current.focus();
  }, [hidden, languageRef]);

  const handleSaveClick = () => {
    setSaving(true);
    onSaveClick(language, description)
      .then(() => setLanguage(''))
      .then(() => toggle())
      .then(() => setSaving(false));
  };

  return (
    <Modal centered hidden={hidden} toggle={toggle}>
      <ModalContent>
        <ModalHeader toggle={toggle}>
          <FontAwesomeIcon icon='language' /> Add Language
        </ModalHeader>
        <ModalBody>
          <p>
            Add a language. You should use the language code for a given
            language like 'es-MX' or 'zh'.
          </p>
          <InputGroup>
            <InputGroupPrepend>
              <InputGroupText>Language</InputGroupText>
            </InputGroupPrepend>
            <TextInput
              inputRef={languageRef}
              placeholder='Code'
              value={language}
              onChange={e => setLanguage(e.target.value)}
            />
            <TextInput
              placeholder='Description'
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </InputGroup>
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Close</Button>
          <Button primary onClick={handleSaveClick} loading={saving}>
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddLanguageModal;
